import {
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Zoom,
} from '@material-ui/core';

import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const PutBoardTableHeadingRow = ({
  styles,
  isMobile,
  topPosition,
  favioute,
  checkPut,
}) => {
  const appState = useSelector((state) => state.appReducer);

  return (
    <TableHead>
      <TableRow style={styles.tableRow}>   
        <TableCell
          style={{ ...styles.tableHeaderCell, top: topPosition }}
          className="sticky"
        >
          Bid
        </TableCell>
        <TableCell
          style={{ ...styles.tableHeaderCell, top: topPosition }}
          className="sticky"
        >
          Ask
        </TableCell>
        <TableCell
          style={{ ...styles.tableHeaderCell, top: topPosition }}
          className="sticky"
        >
          Volume
        </TableCell>

        {!isMobile && (
          <TableCell
            style={{
              ...styles.tableHeaderCell,
              top: topPosition,
              cursor: 'pointer',
            }}
            className="sticky"
          >
            <Link
              onClick={() => {
                if (appState.ticker !== '') {
                  localStorage.setItem('TYPE', 'puts');
                }
              }}
              style={{ color: 'blue' }}
              to="/openinterest"
            >
              OI
            </Link>
          </TableCell>
        )}
        {!isMobile && (
          <Tooltip
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 700 }}
            placement="top"
            PopperProps={{
              style: styles.tooltip,
            }}
            title="The Risk Reward Breakeven Price shows the market’s expected Stock Price AT EXPIRATION that equalizes the risk and reward of the option."
          >
            <TableCell
              style={{ ...styles.RRHeaderCell, top: topPosition }}
              className="sticky"
            >
              RR$
            </TableCell>
          </Tooltip>
        )}
        {favioute && checkPut.length && (
          <TableCell
            style={{
              ...styles.tableHeaderCell,
              top: topPosition,
            }}
            className="sticky"
          ></TableCell>
        )}
      </TableRow>
    </TableHead>
  );
};
export default PutBoardTableHeadingRow;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/BasicPutBoard/basiCPutBoardWeb/PutBoardTableHeadingRow.jsx